import comp from "./ScreenBaseComponent";
export default comp;
